module.exports = __webpack_public_path__ + "img/marker.89a94a20.png";